import { useState } from 'react'
import { FilterButton } from '@/components/FilterButton'
import { IconName } from '@/components/Icon'

const sampleIcon: IconName = 'FilterHandles'

const BEDROOM_OPTIONS = ['Studio', '1 bd', '2 bd', '3 bd', '4+ bd']

export function FilterButtonSandbox () {
	const [bedroomsActive, setBedroomsActive] = useState(false)
	const [priceActive, setPriceActive] = useState(false)
	const [availableActive, setAvailableActive] = useState(false)
	const [selectedBedrooms, setSelectedBedrooms] = useState<string[]>([])

	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-32'>
			{/* ── States ── */}
			<Section title='States'>
				<div className='spaces:flex spaces:flex-wrap spaces:items-center spaces:gap-16'>
					<div className='spaces:flex spaces:flex-col spaces:items-start spaces:gap-8'>
						<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
							default
						</span>
						<FilterButton label='Bedrooms'>
							<div className='spaces:p-16 spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2'>
								Popover content
							</div>
						</FilterButton>
					</div>

					<div className='spaces:flex spaces:flex-col spaces:items-start spaces:gap-8'>
						<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
							active
						</span>
						<FilterButton label='Bedrooms' activeLabel='2–3 bd' onClear={() => {}}>
							<div className='spaces:p-16 spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2'>
								Popover content
							</div>
						</FilterButton>
					</div>
				</div>
			</Section>

			{/* ── With icon ── */}
			<Section title='With Icon'>
				<div className='spaces:flex spaces:flex-wrap spaces:items-center spaces:gap-16'>
					<div className='spaces:flex spaces:flex-col spaces:items-start spaces:gap-8'>
						<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
							default
						</span>
						<FilterButton label='Filters' icon={sampleIcon}>
							<div className='spaces:p-16 spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2'>
								Popover content
							</div>
						</FilterButton>
					</div>

					<div className='spaces:flex spaces:flex-col spaces:items-start spaces:gap-8'>
						<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
							active
						</span>
						<FilterButton
							label='Filters'
							icon={sampleIcon}
							activeLabel='3 active'
							onClear={() => {}}
						>
							<div className='spaces:p-16 spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2'>
								Popover content
							</div>
						</FilterButton>
					</div>
				</div>
			</Section>

			{/* ── Long active label ── */}
			<Section title='Long Active Label (truncates at 160px)'>
				<div className='spaces:flex spaces:flex-wrap spaces:items-center spaces:gap-16'>
					<FilterButton
						label='Move-in Date'
						activeLabel='January 1 – February 28, 2025'
						onClear={() => {}}
					>
						<div className='spaces:p-16 spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2'>
							Popover content
						</div>
					</FilterButton>
				</div>
			</Section>

			{/* ── Additional count ── */}
			<Section title='Additional Count (+x)'>
				<div className='spaces:flex spaces:flex-wrap spaces:items-center spaces:gap-16'>
					<div className='spaces:flex spaces:flex-col spaces:items-start spaces:gap-8'>
						<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>+1</span>
						<FilterButton
							label='Bedrooms'
							activeLabel='Studio'
							additionalCount={1}
							onClear={() => {}}
						>
							<div className='spaces:p-16 spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2'>
								Popover content
							</div>
						</FilterButton>
					</div>

					<div className='spaces:flex spaces:flex-col spaces:items-start spaces:gap-8'>
						<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>+3</span>
						<FilterButton
							label='Bedrooms'
							activeLabel='Studio'
							additionalCount={3}
							onClear={() => {}}
						>
							<div className='spaces:p-16 spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2'>
								Popover content
							</div>
						</FilterButton>
					</div>

					<div className='spaces:flex spaces:flex-col spaces:items-start spaces:gap-8'>
						<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
							truncated + count
						</span>
						<FilterButton
							label='Amenities'
							activeLabel='Rooftop Pool & Lounge'
							additionalCount={4}
							onClear={() => {}}
						>
							<div className='spaces:p-16 spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2'>
								Popover content
							</div>
						</FilterButton>
					</div>
				</div>
			</Section>

			{/* ── Interactive multi-select ── */}
			<Section title='Interactive Multi-Select'>
				{(() => {
					const primary = selectedBedrooms[0]
					const additionalCount =
						selectedBedrooms.length > 1 ? selectedBedrooms.length - 1 : undefined
					const toggle = (opt: string) =>
						setSelectedBedrooms(prev =>
							prev.includes(opt) ? prev.filter(o => o !== opt) : [...prev, opt]
						)
					return primary ? (
						<FilterButton
							label='Bedrooms'
							activeLabel={primary}
							additionalCount={additionalCount}
							onClear={() => setSelectedBedrooms([])}
						>
							<div className='spaces:flex spaces:flex-col spaces:gap-4 spaces:p-16'>
								{BEDROOM_OPTIONS.map(opt => (
									<button
										key={opt}
										className={`spaces:text-left spaces:text-14 spaces:leading-24 spaces:font-default spaces:transition-colors spaces:px-8 spaces:py-4 spaces:rounded-8 ${
											selectedBedrooms.includes(opt)
												? 'spaces:text-brand-base spaces:font-semi'
												: 'spaces:text-content-2 spaces:hover:text-content-1'
										}`}
										onClick={() => toggle(opt)}
									>
										{selectedBedrooms.includes(opt) ? '✓ ' : ''}
										{opt}
									</button>
								))}
							</div>
						</FilterButton>
					) : (
						<FilterButton label='Bedrooms'>
							<div className='spaces:flex spaces:flex-col spaces:gap-4 spaces:p-16'>
								{BEDROOM_OPTIONS.map(opt => (
									<button
										key={opt}
										className='spaces:text-left spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2 spaces:hover:text-content-1 spaces:transition-colors spaces:px-8 spaces:py-4 spaces:rounded-8'
										onClick={() => toggle(opt)}
									>
										{opt}
									</button>
								))}
							</div>
						</FilterButton>
					)
				})()}
			</Section>

			{/* ── Interactive ── */}
			<Section title='Interactive (click to toggle active state)'>
				<div className='spaces:flex spaces:flex-wrap spaces:items-center spaces:gap-16'>
					{bedroomsActive ? (
						<FilterButton
							label='Bedrooms'
							activeLabel='2–3 bd'
							onClear={() => setBedroomsActive(false)}
						>
							<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:p-16'>
								<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
									Select bedrooms
								</span>
								<button
									className='spaces:text-left spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2 spaces:hover:text-content-1 spaces:transition-colors'
									onClick={() => setBedroomsActive(true)}
								>
									2–3 bedrooms
								</button>
							</div>
						</FilterButton>
					) : (
						<FilterButton label='Bedrooms'>
							<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:p-16'>
								<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
									Select bedrooms
								</span>
								<button
									className='spaces:text-left spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2 spaces:hover:text-content-1 spaces:transition-colors'
									onClick={() => setBedroomsActive(true)}
								>
									2–3 bedrooms
								</button>
							</div>
						</FilterButton>
					)}

					{priceActive ? (
						<FilterButton
							label='Price'
							activeLabel='$1,200 – $2,400'
							onClear={() => setPriceActive(false)}
						>
							<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:p-16'>
								<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
									Select price range
								</span>
								<button
									className='spaces:text-left spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2 spaces:hover:text-content-1 spaces:transition-colors'
									onClick={() => setPriceActive(true)}
								>
									$1,200 – $2,400 / mo
								</button>
							</div>
						</FilterButton>
					) : (
						<FilterButton label='Price'>
							<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:p-16'>
								<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
									Select price range
								</span>
								<button
									className='spaces:text-left spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2 spaces:hover:text-content-1 spaces:transition-colors'
									onClick={() => setPriceActive(true)}
								>
									$1,200 – $2,400 / mo
								</button>
							</div>
						</FilterButton>
					)}

					{availableActive ? (
						<FilterButton
							label='Available'
							icon='Calendar'
							activeLabel='Mar 1 – Mar 31'
							onClear={() => setAvailableActive(false)}
						>
							<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:p-16'>
								<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
									Select availability
								</span>
								<button
									className='spaces:text-left spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2 spaces:hover:text-content-1 spaces:transition-colors'
									onClick={() => setAvailableActive(true)}
								>
									March 2025
								</button>
							</div>
						</FilterButton>
					) : (
						<FilterButton label='Available' icon='Calendar'>
							<div className='spaces:flex spaces:flex-col spaces:gap-8 spaces:p-16'>
								<span className='spaces:text-12 spaces:leading-24 spaces:font-default spaces:text-content-3'>
									Select availability
								</span>
								<button
									className='spaces:text-left spaces:text-14 spaces:leading-24 spaces:font-default spaces:text-content-2 spaces:hover:text-content-1 spaces:transition-colors'
									onClick={() => setAvailableActive(true)}
								>
									March 2025
								</button>
							</div>
						</FilterButton>
					)}
				</div>
			</Section>
		</div>
	)
}

function Section ({
	title,
	children
}: {
	title: string
	children: React.ReactNode
}) {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-12'>
			<h3 className='spaces:text-16 spaces:font-semi spaces:text-content-1'>{title}</h3>
			{children}
		</div>
	)
}
